/** Get the current month as two digits */
export const month = () => {
        const today = new Date();
        const month = today.getMonth() + 1;
        return (month < 10) ? ("0" + month) : month
}
/** Get the current day of the month as two digits */
export const date = () => {
        const today = new Date();
        const date = today.getDate();
        return (date < 10) ? ("0" + date) : date
}
/** Get the current year */
export const year = () => {
        const today = new Date();
        const year = today.getFullYear();
        return (year < 10) ? ("0" + year) : year
}
/** Get the current date in YYYY-MM-DD format */
export const currentDate = () => { return year() + "-" + month() + "-" + date(); }
/** Get the current date in YYYY/MM/DD format */
export const currentDateDataBase = () => { return year() + "/" + month() + "/" + date(); }
/** Get the current hour as two digits */
export const getHour = (): string => {
        const today = new Date();
        const hour = today.getHours();
        return (hour < 10) ? ("0" + hour) : hour.toString();
}
/** Get the current minutes as two digits */
export const getMinutes = (): string => {
        const today = new Date();
        const minutes = today.getMinutes();
        return (minutes < 10) ? ("0" + minutes) : minutes.toString();
}

/** Get the current seconds as two digits */
export const getSeconds = (): string => {
        const today = new Date();
        const seconds = today.getSeconds();
        return (seconds < 10) ? ("0" + seconds) : seconds.toString();
}

/** Get the current time in HH:MM:SS format */
export const getTime = (): string => {
        return `${getHour()}:${getMinutes()}:${getSeconds()}`;
}
export interface urlsfilterdinterface {
        onlydates: string;
        withtimefilter: string;
        withterminalfilter: string;
        onlydatesintermedial: string;
        withParameter: string;
}

/**
 * Build query strings for filtering by the current day.
 *
 * @returns Set of different filter strings.
 */
export const todayFilters = (): urlsfilterdinterface => {
        let onlydates = "?StartDate=" + currentDateDataBase() + " 00:00:00&EndDate=" + currentDateDataBase() + " 23:59:59"
        let onlydatesintermedial = "&StartDate=" + currentDateDataBase() + " 00:00:00&EndDate=" + currentDateDataBase() + " 23:59:59"
        let withtimefilter = "?StartDate=" + currentDateDataBase() + " 00:00:00&EndDate=" + currentDateDataBase() + " 23:59:59&filter=H"
        let withterminalfilter = "?StartDate=" + currentDateDataBase() + " 00:00:00&EndDate=" + currentDateDataBase() + " 23:59:59&Terminals=1"
        let withParameter = "?StartDate=" + currentDateDataBase() + " 00:00:00&EndDate=" + currentDateDataBase() + " 23:59:59&parameter=day"
        return { onlydates, withtimefilter, withterminalfilter, onlydatesintermedial, withParameter }
}

/**
 * Build query strings for filtering by the current month.
 */
export const monthFilters = (): urlsfilterdinterface => {
        let onlydates = "?StartDate=" + +year() + "/" + month() + "/01" + " 00:00:00&EndDate=" + currentDateDataBase() + " 23:59:59"
        let onlydatesintermedial = "&StartDate=" + +year() + "/" + month() + "/01" + " 00:00:00&EndDate=" + currentDateDataBase() + " 23:59:59"
        let withtimefilter = "?StartDate=" + +year() + "/" + month() + "/01" + " 00:00:00&EndDate=" + currentDateDataBase() + " 23:59:59&filter=D"
        let withterminalfilter = "?StartDate=" + +year() + "/" + month() + "/01" + " 00:00:00&EndDate=" + currentDateDataBase() + " 23:59:59&Terminals=1"
        let withParameter = "?StartDate=" + +year() + "/" + month() + "/01" + " 00:00:00&EndDate=" + currentDateDataBase() + " 23:59:59&parameter=month"
        return { onlydates, withtimefilter, withterminalfilter, onlydatesintermedial, withParameter }
}

/**
 * Build query strings for filtering by the current year.
 */
export const yearsFilters = (): urlsfilterdinterface => {
        let onlydates = "?StartDate=" + year() + "/01/01" + " 00:00:00&EndDate=" + currentDateDataBase() + " 23:59:59"
        let onlydatesintermedial = "&StartDate=" + year() + "/01/01" + " 00:00:00&EndDate=" + currentDateDataBase() + " 23:59:59"
        let withtimefilter = "?StartDate=" + year() + "/01/01" + " 00:00:00&EndDate=" + currentDateDataBase() + " 23:59:59&filter=M"
        let withterminalfilter = "?StartDate=" + year() + "/01/01" + " 00:00:00&EndDate=" + currentDateDataBase() + " 23:59:59&Terminals=1"
        let withParameter = "?StartDate=" + year() + "/01/01" + " 00:00:00&EndDate=" + currentDateDataBase() + " 23:59:59&parameter=year"
        return { onlydates, withtimefilter, withterminalfilter, onlydatesintermedial, withParameter }
}
/**
 * Get the current date and time in HTML datetime-local format.
 */
export const getCurrentDateTime = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, "0");
        const day = String(now.getDate()).padStart(2, "0");
        const hours = String(now.getHours()).padStart(2, "0");
        const minutes = String(now.getMinutes()).padStart(2, "0");
        return `${year}-${month}-${day}T${hours}:${minutes}`;
};


